export function convertToMonthly(value: number | null, isYearly: boolean): number | null {
  if (value === null) return null;
  return isYearly ? Math.round((value / 12) * 100) / 100 : value;
}

export function convertFromMonthly(value: number | null, isYearly: boolean): number | null {
  if (value === null) return null;
  return isYearly ? Math.round(value * 12 * 100) / 100 : value;
}

const sumCents = (values: Array<number | null | undefined>): number =>
  values.reduce((total: number, value) => total + (value ?? 0), 0);

export function getDetailedPurchaseCostsTotal(values: {
  itpTax: number | null;
  notaryFees: number | null;
  registryFees: number | null;
  agencyFees: number | null;
  legalFees: number | null;
  otherTransactionCosts: number | null;
}) {
  return sumCents([
    values.itpTax,
    values.notaryFees,
    values.registryFees,
    values.agencyFees,
    values.legalFees,
    values.otherTransactionCosts,
  ]);
}

export function hasDetailedPurchaseCosts(values: {
  itpTax: number | null;
  notaryFees: number | null;
  registryFees: number | null;
  agencyFees: number | null;
  legalFees: number | null;
  otherTransactionCosts: number | null;
}) {
  return getDetailedPurchaseCostsTotal(values) > 0;
}

export function getDetailedMonthlyOpexTotal(values: {
  ibiTax: number | null;
  communityFee: number | null;
  supplyCosts: number | null;
  maintenanceCosts: number | null;
  wasteTax: number | null;
  homeInsurance: number | null;
  rentInsurance: number | null;
  otherOpex: number | null;
}) {
  return sumCents([
    convertToMonthly(values.ibiTax, true),
    convertToMonthly(values.communityFee, false),
    convertToMonthly(values.supplyCosts, false),
    convertToMonthly(values.maintenanceCosts, false),
    convertToMonthly(values.wasteTax, true),
    convertToMonthly(values.homeInsurance, true),
    convertToMonthly(values.rentInsurance, true),
    convertToMonthly(values.otherOpex, false),
  ]);
}

export function hasDetailedMonthlyOpex(values: {
  ibiTax: number | null;
  communityFee: number | null;
  supplyCosts: number | null;
  maintenanceCosts: number | null;
  wasteTax: number | null;
  homeInsurance: number | null;
  rentInsurance: number | null;
  otherOpex: number | null;
}) {
  return getDetailedMonthlyOpexTotal(values) > 0;
}

export function deriveFinancedPercentage(
  loanAmount: number | null,
  acquisitionPrice: number | null
): number | undefined {
  if (loanAmount === null || acquisitionPrice === null || acquisitionPrice <= 0) {
    return undefined;
  }

  return loanAmount / acquisitionPrice;
}
